import React from 'react'
import { LocalizedText, PrimaryNavLink, Rows } from 'labguard-cdk'
import { ChannelIcon } from 'src/components/common'
import LoginForm from './LoginForm'
import styles from './Login.scss'

const Login = () => (
  <Rows className={styles.login} layout="auto" align="center" justify="center">
    <div className={styles.links}>
      <PrimaryNavLink icon={ChannelIcon} color="white" to="/widget">
        <LocalizedText id="WEB_CHANNELS" />
      </PrimaryNavLink>
    </div>
    <LoginForm />
  </Rows>
)

export default Login
